import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { senaLogin } from '../../api/senaApi';
import './SenaAuth.css';

export default function SenaLogin() {
  const navigate = useNavigate();
  const [loginId, setLoginId] = useState('');
  const [passWd, setPassWd] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!loginId || !passWd) { setError('아이디와 비밀번호를 입력해주세요.'); return; }

    setLoading(true);
    setError('');
    try {
      const res = await senaLogin(loginId, passWd);
      const { token, userId, userName, userRole } = res.data;
      localStorage.setItem('token', token);
      localStorage.setItem('userId', userId);
      localStorage.setItem('userName', userName);
      localStorage.setItem('userRole', userRole);
      navigate('/sena');
    } catch (e) {
      const msg = e?.response?.data || '로그인에 실패했습니다.';
      setError(typeof msg === 'string' ? msg : JSON.stringify(msg));
    } finally { setLoading(false); }
  };

  return (
    <div className="sena-page">
      <div className="sena-auth-container">
        <div className="sena-auth-card">
          <h1 className="sena-auth-title">로그인</h1>
          <p className="sena-auth-sub">세나리 추력 길드</p>

          <form onSubmit={handleLogin} className="sena-auth-form">
            <div className="sena-auth-field">
              <label>아이디</label>
              <input type="text" value={loginId} onChange={e => setLoginId(e.target.value)}
                placeholder="아이디 입력" autoFocus />
            </div>
            <div className="sena-auth-field">
              <label>비밀번호</label>
              <input type="password" value={passWd} onChange={e => setPassWd(e.target.value)}
                placeholder="비밀번호 입력" />
            </div>

            {error && <p className="sena-auth-error">{error}</p>}

            <button type="submit" className="sena-auth-btn" disabled={loading}>
              {loading ? '로그인 중...' : '로그인'}
            </button>
          </form>

          <p className="sena-auth-link">
            계정이 없으신가요? <button onClick={() => navigate('/sena/signup')}>회원가입</button>
          </p>
          <p className="sena-auth-link">
            <button onClick={() => navigate('/sena')}>← 메인으로</button>
          </p>
        </div>
      </div>
    </div>
  );
}
